import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

// Recursively rewrite all image paths in content to point to the API server
// e.g. "/images/logo.png" → "https://api.sterealenbatiment.cloud/images/logo.png"
function rewriteImagePaths(obj) {
    if (typeof obj === 'string') {
        // If it's an image path starting with /images/, prefix with API URL
        if (obj.startsWith('/images/')) {
            return `${API_URL}${obj}`;
        }
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(rewriteImagePaths);
    }
    if (typeof obj === 'object' && obj !== null) {
        const result = {};
        for (const key in obj) {
            result[key] = rewriteImagePaths(obj[key]);
        }
        return result;
    }
    return obj;
}

function useContent() {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${API_URL}/api/content`)
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(data => {
                // Rewrite all image paths to point to the API server
                const rewritten = API_URL ? rewriteImagePaths(data) : data;
                setContent(rewritten);
                setLoading(false);
            })
            .catch(err => {
                console.error('Error fetching content:', err);
                setError(err);
                setLoading(false);
            });
    }, []);

    return { content, loading, error };
}

export default useContent;
